import { render, staticRenderFns } from "./About.vue?vue&type=template&id=e7d24b68&scoped=true"
import script from "./About.vue?vue&type=script&lang=ts&setup=true"
export * from "./About.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./About.vue?vue&type=style&index=0&id=e7d24b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d24b68",
  null
  
)

export default component.exports